import { apiWrapper } from '../helper/api-wrapper';

export const joinPromo = async (payload) => {
  try {
    const response = await apiWrapper.post(
      `merchants/cms/promo_apply_product`,
      payload
    );

    return response;
  } catch (error) {
    console.error('Error joining promo:', error);
    throw error;
  }
};

export const productForJoinPromoList = async (payload) => {
  try {
    const response = await apiWrapper.get(
      `merchants/products/promo/join?promoId=${
        payload?.promo_id
      }&query=${encodeURIComponent(payload?.query)}&offset=${encodeURIComponent(
        payload?.offset
      )}&limit=${encodeURIComponent(payload?.limit)}`
    );

    return response;
  } catch (error) {
    console.error('Error fetching product for join promo list:', error);
    throw error;
  }
};

export const getAllPromotions = async (payload) => {
  try {
    const response = await apiWrapper.get(
      `merchants/cms/all_promo?type=${encodeURIComponent(
        payload?.type
      )}&query=${encodeURIComponent(payload?.query)}&sort=${encodeURIComponent(
        payload?.sort
      )}&offset=${encodeURIComponent(
        payload?.offset
      )}&limit=${encodeURIComponent(payload?.limit)}`
    );

    return response;
  } catch (error) {
    console.error('Error fetching all promotions:', error);
    throw error;
  }
};

export const getMyPromotions = async (payload) => {
  try {
    const response = await apiWrapper.get(
      `merchants/cms/my_promo?type=${encodeURIComponent(
        payload?.type
      )}&query=${encodeURIComponent(payload?.query)}&sort=${encodeURIComponent(
        payload?.sort
      )}&offset=${encodeURIComponent(
        payload?.offset
      )}&limit=${encodeURIComponent(payload?.limit)}`
    );

    return response;
  } catch (error) {
    console.error('Error fetching my promotions:', error);
    throw error;
  }
};

export const getDetailPromotion = async (id) => {
  try {
    const response = await apiWrapper.get(
      `merchants/cms/promo/${parseInt(id)}`
    );

    return response;
  } catch (error) {
    console.error('Error fetching promotion detail:', error);
    throw error;
  }
};
